import React from "react";
import UniThumbGridBox from "../components/uni_thumb_grid_box";
import styles from "./uni_list.module.scss";

export const UniList = (props) => {
  const { pageData } = props;

  return (
    <div className={styles.section_uni_list}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.list_wrapper}>
            {pageData.length > 0 &&
              pageData.map((university) => (
                <UniThumbGridBox
                  key={university.id}
                  universityLink={`/study/${university?.country?.slug}/university/${university?.slug}`}
                  name={university?.name}
                  featuredImage={university?.featuredImage?.src}
                  featuredImageAlt={university?.featuredImage?.alt}
                  logo={university?.logo?.src}
                  logoAlt={university?.logo?.alt}
                  address={university?.address}
                  city={university?.city?.name || "City"}
                  state={university?.state?.name || "State"}
                  country={university?.country?.name || "Country"}
                  universityType={university.universityType}
                  estd={university?.estd}
                  courseLink={`/study/${university?.country?.slug}/university/${university?.slug}/courses`}
                  courseNumber={university?.course?.length}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UniList;
